document.addEventListener("DOMContentLoaded", function () {
  const hiddenProductImage = document.querySelectorAll(".pnf-grid .product-image.hide");
  hiddenProductImage.forEach(function (thumb, index) {
   thumb.classList.remove('hide');
  });

  var mainCarousel = new Flickity("#Product-Slider", {
    wrapAround: true,
    draggable: true,
    prevNextButtons: true,
    adaptiveHeight: true,
  });

  var thumbImages = document.querySelectorAll(
    ".product-thumb-images .product-image"
  );

  // Function to update active thumbnail
  function updateActiveThumbnail(index) {
    thumbImages.forEach(function (thumb, i) {
      thumb.classList.toggle("active", i === index);
    });
  }

  // Thumbnail click event
  thumbImages.forEach(function (thumb, index) {
    thumb.addEventListener("click", function () {
      mainCarousel.select(index);
    });
  });

  // Update active thumbnail when the main carousel changes
  mainCarousel.on("change", function (index) {
    updateActiveThumbnail(index);
  });

  // Initialize active thumbnail on load
  updateActiveThumbnail(mainCarousel.selectedIndex);
});
